import { useEffect, useRef, useState } from 'react';

export function OtpValidationFields({
  onOtpChange = (otp: string) => {},
  isOtpValidate = (data: boolean) => {},
  clearOtp = false,
}) {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const inputRefs = useRef<Array<HTMLInputElement | null>>([]);

  useEffect(() => {
    if (clearOtp) {
      setOtp(['', '', '', '', '', '']);
      onOtpChange('');
    }
  }, [clearOtp]);

  const handleChange = (index: number, value: string) => {
    if (value.match(/^\d$/)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (index < 5) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  useEffect(() => {
    const otpString = otp.join('');
    const regex = /\d{6}/;
    isOtpValidate(regex.test(otpString));
  }, [otp]);

  const handleKeyDown = (index: number, event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Backspace') {
      if (index > 0) {
        const newOtp = [...otp];
        if (otp[index]) {
          newOtp[index] = '';
        } else {
          newOtp[index - 1] = '';
          inputRefs.current[index - 1]?.focus();
        }
        setOtp(newOtp);
      } else if (index === 0 && !otp[index]) {
        inputRefs.current[index - 1]?.focus();
      }
    } else if (event.key === 'Enter' && index === 5) {
      onOtpChange(otp.join(''));
    }
  };

  const handleInputChange = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    handleChange(index, value);
    onOtpChange(otp.join(''));
  };

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    const pastedValue = event.clipboardData.getData('text');
    const newOtp = Array(6).fill('');
    pastedValue.split('').forEach((value, index) => {
      if (index < 6) {
        newOtp[index] = value;
      }
    });
    setOtp(newOtp);
    onOtpChange(newOtp.join(''));
    event.preventDefault();
  };

  const handleLastInputBlur = (index: number) => {
    if (otp[index]) {
      onOtpChange(otp.join(''));
    }
  };

  return (
    <>
      <div className="">
        <label htmlFor="otp" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
          Enter code
        </label>
        <div className="mt-1 flex">
          {otp.map((digit, index) => (
            <input
              key={index}
              ref={(ref) => {
                inputRefs.current[index] = ref;
              }}
              id={`otp-${index}`}
              name={`otp-${index}`}
              type="text"
              maxLength={1}
              required
              value={digit}
              className="w-12 h-12 text-3xl text-center rounded-md border border-gray-300 dark:border-gray-700 mx-1 px-2 py-2 text-gray-900 placeholder-gray-400 dark:placeholder-gray-500 shadow-sm sm:text-sm focus:outline-none focus:ring-2 focus:ring-inset focus:ring-black dark:focus:ring-white"
              onChange={(event) => handleInputChange(index, event)}
              onKeyDown={(event) => handleKeyDown(index, event)}
              onBlur={() => {
                if (index === 5) {
                  handleLastInputBlur(index);
                }
              }}
              pattern="[0-9]*"
              inputMode="numeric"
              onPaste={(event) => handlePaste(event)} // Handle paste event
            />
          ))}
        </div>
      </div>
    </>
  );
}

export function OtpFooter({ resendOTP = () => {}, resetEmail = () => {} }) {
  return (
    <div className="flex justify-between">
      <div className="flex flex-row justify-start items-center space-x-1">
        <button
          className={[
            'font-bold text-sm md:text-base',
            'bg-transparent outline-none border-none shadow-none',
            // loginStatus.isLogginIn ? 'pointer-events-none' : 'cursor-pointer',
          ].join(' ')}
          onClick={(event) => {
            event.preventDefault();
            resendOTP();
          }}
        >
          <span>Resend the code?</span>
        </button>
      </div>
      <div className="flex flex-row justify-end items-center space-x-1">
        <button
          className={[
            'font-bold text-sm md:text-base',
            'bg-transparent outline-none border-none shadow-none',
            // loginStatus.isLogginIn ? 'pointer-events-none' : 'cursor-pointer',
          ].join(' ')}
          onClick={(event) => {
            event.preventDefault();
            resetEmail();
          }}
        >
          <span>Access with different email?</span>
        </button>
      </div>
    </div>
  );
}
